import React from 'react';
import * as S from './styles';

const LinkBase64 = ({ children, ...rest }) => (
    <>
        <S.LinkFile {...rest}>{children}</S.LinkFile>
    </>
);

export default LinkBase64;
